import { Distributor, OutTypeName } from '@/config/enums'
import { commonOptions } from '@/config/options'
import dayjs from 'dayjs'
import type { PageContext } from '@zto/zpage-runtime'

// 基础信息
export const AddEditBasicInfoFormItems = [
  {
    label: '发货渠道',
    labelWidth: 130,
    type: 'select',
    prop: 'distributorCode',
    options: commonOptions.distributor,
    default: Distributor.TUXI,
    disabled: true,
    required: true,
    span: 8
  },
  // {
  //   label: '收货门店编号',
  //   labelWidth: 130,
  //   type: 'input',
  //   prop: 'receiveShopCode',
  //   maxlength: 100,
  //   trim: true,
  //   // required: true,
  //   span: 8
  // },
  // {
  //   label: '收货门店名称',
  //   labelWidth: 130,
  //   type: 'input',
  //   prop: 'receiveShopName',
  //   maxlength: 100,
  //   trim: true,
  //   // required: true,
  //   span: 8
  // },
  {
    labelWidth: 130,
    type: 'fuzzy-select',
    prop: 'receiveShopCode',
    labelProp: 'receiveShopName',
    label: '门店名称',
    optionValueProp: 'shopCode',
    optionLabelProp: 'shopName',
    triggerFocus: true,
    remote: true,
    keywordProp: 'shopName',
    api: '/cabinet/admin/base/AdminBaseShopQueryController/queryList',
    span: 8,
    dynamicAttrs: ({ data, app }: PageContext) => {
      return {
        onChange: async (model: any, val: any, ctx: PageContext, ext: any) => {
          // console.info('🚀 ~ file:config method:onChange line:55 ----- model', model)
          // console.info('🚀 ~ file:config method:onChange line:55 ----- val', val)
          // console.info('🚀 ~ file:config method:onChange line:55 ----- ext', ext)
          if (ext.option) {
            const {
              provinceCode,
              cityCode,
              districtCode,
              province,
              city,
              district,
              detailAddress,
              contactName,
              contactPhone
            } = ext.option || {}
            model.receivePCD = [
              {
                receiveProvinceCode: provinceCode,
                receiveProvince: province,
                receiveCityCode: cityCode,
                receiveCity: city,
                receiveDistrictCode: districtCode,
                receiveDistrict: district
              }
            ]
            model.receiveAddress = detailAddress || ''
            model.receiveName = contactName || ''
            model.receiveMobile = contactPhone || ''
          }
        }
      }
    }
  },
  {
    label: '收货省市区',
    labelWidth: 130,
    type: 'area-pro',
    prop: 'receivePCD',
    keyConfig: {
      provinceCode: 'receiveProvinceCode',
      province: 'receiveProvince',
      cityCode: 'receiveCityCode',
      city: 'receiveCity',
      districtCode: 'receiveDistrictCode',
      district: 'receiveDistrict'
    },
    filterable: true,
    // required: true,
    span: 8
  },
  {
    label: '收货详细地址',
    labelWidth: 130,
    maxlength: 50,
    type: 'input',
    prop: 'receiveAddress',
    trim: true,
    // required: true,
    span: 8
  },
  {
    label: '收件人姓名',
    labelWidth: 130,
    maxlength: 50,
    minlength: 2,
    type: 'input',
    prop: 'receiveName',
    trim: true,
    // required: true,
    span: 8
  },
  {
    label: '收件人手机号',
    labelWidth: 130,
    type: 'input',
    prop: 'receiveMobile',
    maxlength: 11,
    trim: true,
    rules: [{ required: false, pattern: /^1[3-9][0-9]\d{8}$/, message: '请填写正确的手机号码' }],
    span: 8
  }
]

// 基础信息
export const BasicInfoFormItems = [
  {
    label: '选择商品',
    type: 'edit-table',
    prop: 'productInfoData',
    noIndex: true,
    noPager: true,
    noOperation: true,
    autoHeight: true,
    border: true,
    showSummary: false,
    columns: [
      { label: '商品编号', prop: 'productCode', minWidth: 100 },
      { label: '商品名称', prop: 'productName', minWidth: 150 },
      { label: '供应商', prop: 'supplierName', minWidth: 100 },
      { label: '商品规格', prop: 'productSpec', minWidth: 100 },
      { label: '成本价（元）', prop: 'costPrice', minWidth: 100 },
      { label: '销售价（元）', prop: 'salePrice', minWidth: 100 },
      { label: '划线价（元）', prop: 'linePrice', minWidth: 100 },
      { label: '发货数量', prop: 'shipCount', minWidth: 100 }
    ],
    span: 24
  },
  { span: 6, type: 'dis-input', prop: 'distributorName', label: '发货渠道' },
  { span: 6, type: 'dis-input', prop: 'receiveShopCode', label: '收货门店编号' },
  { span: 6, type: 'dis-input', prop: 'receiveShopName', label: '收货门店名称' },
  {
    span: 6,
    type: 'dis-input',
    label: '收货省市区',
    formatter: (data: any, { model }: any) => {
      return `${model?.receiveProvince}${model?.receiveCity}${model?.receiveDistrict}`
    }
  },
  { span: 6, type: 'dis-input', prop: 'receiveAddress', label: '收货详细地址' },
  { span: 6, type: 'dis-input', prop: 'receiveName', label: '收件人姓名' },
  { span: 6, type: 'dis-input', prop: 'receiveMobile', label: '收件人手机号' }
]

// 快递信息
export const ExpressInfoFormItems = [
  { span: 6, type: 'dis-input', prop: 'waybillNo', label: '快递单号' },
  { span: 6, type: 'dis-input', prop: 'expressName', label: '发货快递公司' },
  {
    span: 6,
    type: 'dis-input',
    label: '发货时间',
    formatter: (data: any, { model }: any) => {
      return model.shipTime ? dayjs(model.shipTime).format('YYYY-MM-DD HH:mm:ss') : '--'
    }
  }
]

// 入库信息
export const InInfoFormItems = [
  { span: 6, type: 'dis-input', prop: 'inShopCode', label: '入库门店编号' },
  { span: 6, type: 'dis-input', prop: 'inShopName', label: '入库门店名称' },
  { span: 6, type: 'dis-input', prop: 'inCabinetCode', label: '入库柜机编号' },
  { span: 6, type: 'dis-input', prop: 'inCabinetSerialNumber', label: '入库柜机序号' },
  { span: 6, type: 'dis-input', prop: 'inCabinetCell', label: '入库柜机格口' },
  {
    span: 6,
    type: 'dis-input',
    label: '入库柜机地址',
    formatter: (data: any, { model }: any) => {
      return `${model?.inCabinetProvince}${model?.inCabinetCity}${model?.inCabinetDistrict}${model?.inCabinetAddress}`
    }
  },
  {
    span: 6,
    type: 'dis-input',
    label: '柜机经纬度',
    formatter: (data: any, { model }: any) => {
      return model?.inCabinetLongitude && model?.inCabinetLatitude
        ? `${model?.inCabinetLongitude}, ${model?.inCabinetLatitude}`
        : '--'
    }
  },
  { span: 6, type: 'dis-input', prop: 'inPickupCode', label: '取件码' },
  { span: 6, type: 'dis-input', prop: 'inExpressName', label: '入库快递公司' }
]

// 出库信息
export const OutInfpFormItems = [
  {
    span: 6,
    type: 'dis-input',
    label: '出库类型',
    formatter: (data: any, { model }: any) => {
      return (OutTypeName as any)[model.outType] || model.outType
    }
  },
  {
    span: 6,
    type: 'dis-input',
    label: '出库时间',
    formatter: (data: any, { model }: any) => {
      return model.outTime ? dayjs(model.outTime).format('YYYY-MM-DD HH:mm:ss') : '--'
    }
  }
]
